import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BusinessContactDialogComponent} from './dialogs/business-contact-dialog/business-contact-dialog.component';
import {ControlsModule} from '../framework/controls/controls.module';
import {ReactiveFormsModule} from '@angular/forms';

@NgModule({
    declarations: [BusinessContactDialogComponent],
    imports: [
        CommonModule,
        ControlsModule,
        ReactiveFormsModule
    ],
    entryComponents: [
        BusinessContactDialogComponent
    ]
})
export class BusinessContactModule {
}
